import { useState, useEffect } from "@wordpress/element";
import { __ as wpTranslate } from "@wordpress/i18n";
import { allTranslations } from "../lib/all-translations";

// Built-in translations for fallback - now using comprehensive translations
const translations = allTranslations;

export const useTranslation = () => {
	const [currentLanguage, setCurrentLanguage] = useState(() => {
		const saved = localStorage.getItem("accessibly-wp-language");
		//console.log("🌐 Initial language from localStorage:", saved);
		return saved || "en_US";
	});

	const [, forceUpdate] = useState({});

	// Custom translation function
	const __ = (text, domain = "accessibly-wp") => {
		// Try WordPress i18n first
		if (
			window.wp &&
			window.wp.i18n &&
			typeof window.wp.i18n.__ === "function"
		) {
			const translated = window.wp.i18n.__(text, domain);
			if (translated !== text) {
				// console.log(
				// 	"🔤 WordPress translation found for:",
				// 	text,
				// 	"→",
				// 	translated,
				// );
				return translated;
			}
		}

		// Fallback to our built-in translations
		const fallbackTranslation = translations[currentLanguage]?.[text];
		if (fallbackTranslation && fallbackTranslation !== text) {
			// console.log(
			// 	"🔤 Fallback translation for:",
			// 	text,
			// 	"→",
			// 	fallbackTranslation,
			// 	"Language:",
			// 	currentLanguage,
			// );
			return fallbackTranslation;
		}

		// console.log("🔤 No translation found, using original:", text);
		return text;
	};

	useEffect(() => {
		const handleLanguageChange = (event) => {
			// console.log("🌐 Language change event received:", event.detail.language);
			// console.log("🌐 Previous language:", currentLanguage);

			setCurrentLanguage(event.detail.language);

			// Force re-render to update all translations
			forceUpdate({});

			// console.log("🌐 Language updated to:", event.detail.language);
			// console.log(
			// 	"🌐 localStorage value:",
			// 	localStorage.getItem("accessibly-wp-language"),
			// );
		};

		// Listen for language changes
		window.addEventListener("languageChanged", handleLanguageChange);

		// Also listen for storage changes (if changed in another tab)
		const handleStorageChange = (event) => {
			if (event.key === "accessibly-wp-language") {
				//console.log("🌐 Language changed via storage:", event.newValue);
				setCurrentLanguage(event.newValue || "en_US");
				forceUpdate({});
			}
		};

		window.addEventListener("storage", handleStorageChange);

		return () => {
			window.removeEventListener("languageChanged", handleLanguageChange);
			window.removeEventListener("storage", handleStorageChange);
		};
	}, []); // Remove currentLanguage from dependency array to prevent re-adding listeners

	// Debug logging
	useEffect(() => {
		// console.log(
		// 	"🌐 Translation hook - Current language state:",
		// 	currentLanguage,
		// );
	}, [currentLanguage]);

	return { __, currentLanguage };
};
